import { lazy } from 'react'
export const lazyIcons = {
  BrandIconAcai: lazy(() => import('./BrandIconAcai.js')),
  BrandIconAccessiblePharmacy: lazy(
    () => import('./BrandIconAccessiblePharmacy.js'),
  ),
  BrandIconActionInApp: lazy(() => import('./BrandIconActionInApp.js')),
  BrandIconAddress: lazy(() => import('./BrandIconAddress.js')),
  BrandIconAirplane: lazy(() => import('./BrandIconAirplane.js')),
  BrandIconAllergy: lazy(() => import('./BrandIconAllergy.js')),
  BrandIconAloeVera: lazy(() => import('./BrandIconAloeVera.js')),
  BrandIconAmpoule: lazy(() => import('./BrandIconAmpoule.js')),
  BrandIconAmpouleWithLid: lazy(() => import('./BrandIconAmpouleWithLid.js')),
  BrandIconApp: lazy(() => import('./BrandIconApp.js')),
  BrandIconArteriesAndBloodCapillaries: lazy(
    () => import('./BrandIconArteriesAndBloodCapillaries.js'),
  ),
  BrandIconBaby: lazy(() => import('./BrandIconBaby.js')),
  BrandIconBabyBear: lazy(() => import('./BrandIconBabyBear.js')),
  BrandIconBack: lazy(() => import('./BrandIconBack.js')),
  BrandIconBarcode: lazy(() => import('./BrandIconBarcode.js')),
  BrandIconBathSalts: lazy(() => import('./BrandIconBathSalts.js')),
  BrandIconBeauty: lazy(() => import('./BrandIconBeauty.js')),
  BrandIconBeautyFemale: lazy(() => import('./BrandIconBeautyFemale.js')),
  BrandIconBeautyMale: lazy(() => import('./BrandIconBeautyMale.js')),
  BrandIconBillboard: lazy(() => import('./BrandIconBillboard.js')),
  BrandIconBladder: lazy(() => import('./BrandIconBladder.js')),
  BrandIconBloodPressure: lazy(() => import('./BrandIconBloodPressure.js')),
  BrandIconBlueberries: lazy(() => import('./BrandIconBlueberries.js')),
  BrandIconBone: lazy(() => import('./BrandIconBone.js')),
  BrandIconBoneAndJoints: lazy(() => import('./BrandIconBoneAndJoints.js')),
  BrandIconBookmark: lazy(() => import('./BrandIconBookmark.js')),
  BrandIconBrain: lazy(() => import('./BrandIconBrain.js')),
  BrandIconBrand: lazy(() => import('./BrandIconBrand.js')),
  BrandIconBundle: lazy(() => import('./BrandIconBundle.js')),
  BrandIconBusinessIdea: lazy(() => import('./BrandIconBusinessIdea.js')),
  BrandIconCalendar: lazy(() => import('./BrandIconCalendar.js')),
  BrandIconCapsule: lazy(() => import('./BrandIconCapsule.js')),
  BrandIconCar: lazy(() => import('./BrandIconCar.js')),
  BrandIconCat: lazy(() => import('./BrandIconCat.js')),
  BrandIconCategories: lazy(() => import('./BrandIconCategories.js')),
  BrandIconCellDivision: lazy(() => import('./BrandIconCellDivision.js')),
  BrandIconCheckmark: lazy(() => import('./BrandIconCheckmark.js')),
  BrandIconCheckmarkInApp: lazy(() => import('./BrandIconCheckmarkInApp.js')),
  BrandIconChildrenColdsAndFlu: lazy(
    () => import('./BrandIconChildrenColdsAndFlu.js'),
  ),
  BrandIconCholesterol: lazy(() => import('./BrandIconCholesterol.js')),
  BrandIconCircularPatch: lazy(() => import('./BrandIconCircularPatch.js')),
  BrandIconClover: lazy(() => import('./BrandIconClover.js')),
  BrandIconCold: lazy(() => import('./BrandIconCold.js')),
  BrandIconCollectRedPoints: lazy(
    () => import('./BrandIconCollectRedPoints.js'),
  ),
  BrandIconCologne: lazy(() => import('./BrandIconCologne.js')),
  BrandIconCommunication: lazy(() => import('./BrandIconCommunication.js')),
  BrandIconCompass: lazy(() => import('./BrandIconCompass.js')),
  BrandIconContactLenses: lazy(() => import('./BrandIconContactLenses.js')),
  BrandIconCourierBike: lazy(() => import('./BrandIconCourierBike.js')),
  BrandIconCranberry: lazy(() => import('./BrandIconCranberry.js')),
  BrandIconCreme: lazy(() => import('./BrandIconCreme.js')),
  BrandIconCristal: lazy(() => import('./BrandIconCristal.js')),
  BrandIconCurcuma: lazy(() => import('./BrandIconCurcuma.js')),
  BrandIconCustomers: lazy(() => import('./BrandIconCustomers.js')),
  BrandIconDecision: lazy(() => import('./BrandIconDecision.js')),
  BrandIconDeliveryPerson: lazy(() => import('./BrandIconDeliveryPerson.js')),
  BrandIconDevices: lazy(() => import('./BrandIconDevices.js')),
  BrandIconDiagestion: lazy(() => import('./BrandIconDiagestion.js')),
  BrandIconDissolvingTablet: lazy(
    () => import('./BrandIconDissolvingTablet.js'),
  ),
  BrandIconDna: lazy(() => import('./BrandIconDna.js')),
  BrandIconDoctor: lazy(() => import('./BrandIconDoctor.js')),
  BrandIconDog: lazy(() => import('./BrandIconDog.js')),
  BrandIconDonation: lazy(() => import('./BrandIconDonation.js')),
  BrandIconDrops: lazy(() => import('./BrandIconDrops.js')),
  BrandIconDrugSuggestion: lazy(() => import('./BrandIconDrugSuggestion.js')),
  BrandIconDumbbell: lazy(() => import('./BrandIconDumbbell.js')),
  BrandIconEar: lazy(() => import('./BrandIconEar.js')),
  BrandIconElectronicPrescription: lazy(
    () => import('./BrandIconElectronicPrescription.js'),
  ),
  BrandIconEucalyptus: lazy(() => import('./BrandIconEucalyptus.js')),
  BrandIconEuro: lazy(() => import('./BrandIconEuro.js')),
  BrandIconExpressDelivery: lazy(() => import('./BrandIconExpressDelivery.js')),
  BrandIconExtraRedPoints: lazy(() => import('./BrandIconExtraRedPoints.js')),
  BrandIconEye: lazy(() => import('./BrandIconEye.js')),
  BrandIconFemaleHealth: lazy(() => import('./BrandIconFemaleHealth.js')),
  BrandIconFenugreek: lazy(() => import('./BrandIconFenugreek.js')),
  BrandIconFever: lazy(() => import('./BrandIconFever.js')),
  BrandIconFindDrugWithApp: lazy(() => import('./BrandIconFindDrugWithApp.js')),
  BrandIconFlyer: lazy(() => import('./BrandIconFlyer.js')),
  BrandIconFoot: lazy(() => import('./BrandIconFoot.js')),
  BrandIconForbiddance: lazy(() => import('./BrandIconForbiddance.js')),
  BrandIconFormFilling: lazy(() => import('./BrandIconFormFilling.js')),
  BrandIconFree: lazy(() => import('./BrandIconFree.js')),
  BrandIconGel: lazy(() => import('./BrandIconGel.js')),
  BrandIconGermanyPharmacy: lazy(() => import('./BrandIconGermanyPharmacy.js')),
  BrandIconGinger: lazy(() => import('./BrandIconGinger.js')),
  BrandIconGinkgo: lazy(() => import('./BrandIconGinkgo.js')),
  BrandIconGinseng: lazy(() => import('./BrandIconGinseng.js')),
  BrandIconGrowth: lazy(() => import('./BrandIconGrowth.js')),
  BrandIconHair: lazy(() => import('./BrandIconHair.js')),
  BrandIconHalloweenBat: lazy(() => import('./BrandIconHalloweenBat.js')),
  BrandIconHalloweenGhost: lazy(() => import('./BrandIconHalloweenGhost.js')),
  BrandIconHand: lazy(() => import('./BrandIconHand.js')),
  BrandIconHead: lazy(() => import('./BrandIconHead.js')),
  BrandIconHeart: lazy(() => import('./BrandIconHeart.js')),
  BrandIconHempCbd: lazy(() => import('./BrandIconHempCbd.js')),
  BrandIconHorse: lazy(() => import('./BrandIconHorse.js')),
  BrandIconIncreaseMetabolism: lazy(
    () => import('./BrandIconIncreaseMetabolism.js'),
  ),
  BrandIconInfo: lazy(() => import('./BrandIconInfo.js')),
  BrandIconInternationalDelivery: lazy(
    () => import('./BrandIconInternationalDelivery.js'),
  ),
  BrandIconKey: lazy(() => import('./BrandIconKey.js')),
  BrandIconKidneys: lazy(() => import('./BrandIconKidneys.js')),
  BrandIconLemon: lazy(() => import('./BrandIconLemon.js')),
  BrandIconLightBoxForAdvertising: lazy(
    () => import('./BrandIconLightBoxForAdvertising.js'),
  ),
  BrandIconLike: lazy(() => import('./BrandIconLike.js')),
  BrandIconLips: lazy(() => import('./BrandIconLips.js')),
  BrandIconLiquid: lazy(() => import('./BrandIconLiquid.js')),
  BrandIconLiver: lazy(() => import('./BrandIconLiver.js')),
  BrandIconLoading: lazy(() => import('./BrandIconLoading.js')),
  BrandIconLocation: lazy(() => import('./BrandIconLocation.js')),
  BrandIconLozengeSplitted: lazy(() => import('./BrandIconLozengeSplitted.js')),
  BrandIconLungs: lazy(() => import('./BrandIconLungs.js')),
  BrandIconManufacturer: lazy(() => import('./BrandIconManufacturer.js')),
  BrandIconMaracuja: lazy(() => import('./BrandIconMaracuja.js')),
  BrandIconMarketplace: lazy(() => import('./BrandIconMarketplace.js')),
  BrandIconMeditationAndYoga: lazy(
    () => import('./BrandIconMeditationAndYoga.js'),
  ),
  BrandIconMetabolism: lazy(() => import('./BrandIconMetabolism.js')),
  BrandIconMilkThistle: lazy(() => import('./BrandIconMilkThistle.js')),
  BrandIconMint: lazy(() => import('./BrandIconMint.js')),
  BrandIconMouth: lazy(() => import('./BrandIconMouth.js')),
  BrandIconMultiplyRedPoints: lazy(
    () => import('./BrandIconMultiplyRedPoints.js'),
  ),
  BrandIconMuscle: lazy(() => import('./BrandIconMuscle.js')),
  BrandIconNail: lazy(() => import('./BrandIconNail.js')),
  BrandIconNetwork: lazy(() => import('./BrandIconNetwork.js')),
  BrandIconNewYear: lazy(() => import('./BrandIconNewYear.js')),
  BrandIconNfcPrimaryOption: lazy(
    () => import('./BrandIconNfcPrimaryOption.js'),
  ),
  BrandIconNfcSecondaryOption: lazy(
    () => import('./BrandIconNfcSecondaryOption.js'),
  ),
  BrandIconNight: lazy(() => import('./BrandIconNight.js')),
  BrandIconNoSmoking: lazy(() => import('./BrandIconNoSmoking.js')),
  BrandIconNose: lazy(() => import('./BrandIconNose.js')),
  BrandIconNoseSpray: lazy(() => import('./BrandIconNoseSpray.js')),
  BrandIconNowDelivery: lazy(() => import('./BrandIconNowDelivery.js')),
  BrandIconObjective: lazy(() => import('./BrandIconObjective.js')),
  BrandIconObjectiveWithRedcareSign: lazy(
    () => import('./BrandIconObjectiveWithRedcareSign.js'),
  ),
  BrandIconOnlinePharmacy: lazy(() => import('./BrandIconOnlinePharmacy.js')),
  BrandIconOrange: lazy(() => import('./BrandIconOrange.js')),
  BrandIconPackage: lazy(() => import('./BrandIconPackage.js')),
  BrandIconPatch: lazy(() => import('./BrandIconPatch.js')),
  BrandIconPercentages: lazy(() => import('./BrandIconPercentages.js')),
  BrandIconPharmacyInGermany: lazy(
    () => import('./BrandIconPharmacyInGermany.js'),
  ),
  BrandIconPickUp: lazy(() => import('./BrandIconPickUp.js')),
  BrandIconPiggyBank: lazy(() => import('./BrandIconPiggyBank.js')),
  BrandIconPill: lazy(() => import('./BrandIconPill.js')),
  BrandIconPillBlister: lazy(() => import('./BrandIconPillBlister.js')),
  BrandIconPlantbasedProduct: lazy(
    () => import('./BrandIconPlantbasedProduct.js'),
  ),
  BrandIconPost: lazy(() => import('./BrandIconPost.js')),
  BrandIconPowder: lazy(() => import('./BrandIconPowder.js')),
  BrandIconPower: lazy(() => import('./BrandIconPower.js')),
  BrandIconPregnancy: lazy(() => import('./BrandIconPregnancy.js')),
  BrandIconPrescriptionBonus: lazy(
    () => import('./BrandIconPrescriptionBonus.js'),
  ),
  BrandIconPresent: lazy(() => import('./BrandIconPresent.js')),
  BrandIconPrintAdvertisement: lazy(
    () => import('./BrandIconPrintAdvertisement.js'),
  ),
  BrandIconProcess: lazy(() => import('./BrandIconProcess.js')),
  BrandIconProtection: lazy(() => import('./BrandIconProtection.js')),
  BrandIconPumpkin: lazy(() => import('./BrandIconPumpkin.js')),
  BrandIconQuestion: lazy(() => import('./BrandIconQuestion.js')),
  BrandIconQuote: lazy(() => import('./BrandIconQuote.js')),
  BrandIconRating: lazy(() => import('./BrandIconRating.js')),
  BrandIconRealisticHeart: lazy(() => import('./BrandIconRealisticHeart.js')),
  BrandIconRedcareWebShop: lazy(() => import('./BrandIconRedcareWebShop.js')),
  BrandIconRegularPrescription: lazy(
    () => import('./BrandIconRegularPrescription.js'),
  ),
  BrandIconSachet: lazy(() => import('./BrandIconSachet.js')),
  BrandIconSale: lazy(() => import('./BrandIconSale.js')),
  BrandIconSaveChf: lazy(() => import('./BrandIconSaveChf.js')),
  BrandIconSaveEuro: lazy(() => import('./BrandIconSaveEuro.js')),
  BrandIconSavings: lazy(() => import('./BrandIconSavings.js')),
  BrandIconScanBarcode: lazy(() => import('./BrandIconScanBarcode.js')),
  BrandIconScanQrCode: lazy(() => import('./BrandIconScanQrCode.js')),
  BrandIconScanWithApp: lazy(() => import('./BrandIconScanWithApp.js')),
  BrandIconSelectionInApp: lazy(() => import('./BrandIconSelectionInApp.js')),
  BrandIconShield: lazy(() => import('./BrandIconShield.js')),
  BrandIconShippingTracking: lazy(
    () => import('./BrandIconShippingTracking.js'),
  ),
  BrandIconShopping: lazy(() => import('./BrandIconShopping.js')),
  BrandIconShoppingBag: lazy(() => import('./BrandIconShoppingBag.js')),
  BrandIconSicknessNausea: lazy(() => import('./BrandIconSicknessNausea.js')),
  BrandIconSkinProblems: lazy(() => import('./BrandIconSkinProblems.js')),
  BrandIconSkincare: lazy(() => import('./BrandIconSkincare.js')),
  BrandIconSkincareIngredient: lazy(
    () => import('./BrandIconSkincareIngredient.js'),
  ),
  BrandIconSnacks: lazy(() => import('./BrandIconSnacks.js')),
  BrandIconSnowflake: lazy(() => import('./BrandIconSnowflake.js')),
  BrandIconSportsBottle: lazy(() => import('./BrandIconSportsBottle.js')),
  BrandIconSpray: lazy(() => import('./BrandIconSpray.js')),
  BrandIconStomach: lazy(() => import('./BrandIconStomach.js')),
  BrandIconStrategy: lazy(() => import('./BrandIconStrategy.js')),
  BrandIconSun: lazy(() => import('./BrandIconSun.js')),
  BrandIconSunscreen: lazy(() => import('./BrandIconSunscreen.js')),
  BrandIconSupport: lazy(() => import('./BrandIconSupport.js')),
  BrandIconSuppositories: lazy(() => import('./BrandIconSuppositories.js')),
  BrandIconSustainability: lazy(() => import('./BrandIconSustainability.js')),
  BrandIconSwissFranc: lazy(() => import('./BrandIconSwissFranc.js')),
  BrandIconSyringe: lazy(() => import('./BrandIconSyringe.js')),
  BrandIconSyrup: lazy(() => import('./BrandIconSyrup.js')),
  BrandIconTonometer: lazy(() => import('./BrandIconTonometer.js')),
  BrandIconTooth: lazy(() => import('./BrandIconTooth.js')),
  BrandIconTransport: lazy(() => import('./BrandIconTransport.js')),
  BrandIconTv: lazy(() => import('./BrandIconTv.js')),
  BrandIconValerian: lazy(() => import('./BrandIconValerian.js')),
  BrandIconVegan: lazy(() => import('./BrandIconVegan.js')),
  BrandIconVideo: lazy(() => import('./BrandIconVideo.js')),
  BrandIconVoucher: lazy(() => import('./BrandIconVoucher.js')),
  BrandIconWarehouse: lazy(() => import('./BrandIconWarehouse.js')),
  BrandIconWebShop: lazy(() => import('./BrandIconWebShop.js')),
}
